import React, { useRef, useEffect, useCallback, useState} from 'react';
import Colors from "components/Colors.js"
import SourceResults from './SourceResults.js';
import {connect} from 'react-redux';
import {useScroll} from './useScroll.js';

const colors = new Colors();

const has = (r) => Object.keys(r) > 0;

const count = (day) => {
    let c = 0;
    for (let source in day.discogs) {
        c+= day.discogs[source].length;
    }
    for (let source in day.youtube) {
        c+= day.youtube[source].length;
    }
    c+= day.unsourced.length;
    return c;
}

const ListResults = ({
    showPianoRoll,
    bottomHeight,
    results,
    isPack,
    sequencerEngine,
    searchTerm,
    setSearchTerm,
    sourceToSearch,
    packToSearch,
    setPackToSearch,
    loadEverything,
    scrollRef
}) => { 
    let ref = useRef(undefined);
    let list = [];
    let {size} = useScroll(scrollRef, 30, true);
    let i=0;
    let resultsCount = 0;
    let _results = [];
    for (let day of results) {
        let {discogs, date, youtube, unsourced} = day;
        let unsourcedResults = [];
        for (let tag in unsourced) {
            unsourcedResults = [... unsourcedResults, ... unsourced[tag]];
        }
        
        for (let coverArtHash in discogs) {
            let resultsSize = size - resultsCount;
            if (resultsSize > 0) {
                list.push(
                    <SourceResults
                      resultsCounter={resultsCount}
                      packToSearch={packToSearch}
                      isPack={isPack}
                      loadEverything={loadEverything}
                      scrollRef={scrollRef}
                      sourceToSearch={sourceToSearch}
                      odd={++i % 2 === 0}
                      setPackToSearch={setPackToSearch}
                      setSearchTerm={setSearchTerm}
                      key={i}
                      resultsSize={resultsSize}
                      sequencerEngine={sequencerEngine}
                      source={{results: discogs[coverArtHash], coverArtHash}}
                    />);
                resultsCount += Math.min(resultsSize, discogs[coverArtHash].length);
            }
            _results = [... _results, ...discogs[coverArtHash]];
        }
        for (let videoId in youtube) {
            let resultsSize = size - resultsCount;
            if (resultsSize > 0) {
                list.push(
                    <SourceResults
                      odd={++i % 2 === 0}
                      scrollRef={scrollRef}
                      resultsCounter={resultsCount}
                      setPackToSearch={setPackToSearch}
                      packToSearch={packToSearch}
                      isPack={isPack}
                      loadEverything={loadEverything}
                      key={i}
                      sourceToSearch={sourceToSearch}
                      resultsSize={resultsSize}
                      setSearchTerm={setSearchTerm}
                      sequencerEngine={sequencerEngine}
                      source={{results: youtube[videoId], videoId}}
                    />);
                resultsCount += Math.min(resultsSize, youtube[videoId].length);
            }
            _results = [... _results, ...youtube[videoId]];
        }

        for (let tag in unsourced) {
            let resultsSize = size - resultsCount;
            if (resultsSize > 0) {
                list.push(
                    <SourceResults
                      odd={++i % 2 === 0}
                      scrollRef={scrollRef}
                      setPackToSearch={setPackToSearch}
                      loadEverything={loadEverything}
                      key={i}
                      packToSearch={packToSearch}
                      isPack={isPack}
                      resultsCounter={resultsCount}
                      setSearchTerm={setSearchTerm}
                      resultsSize={resultsSize}
                      sourceToSearch={sourceToSearch}
                      sequencerEngine={sequencerEngine}
                      source={{results: unsourced[tag], tag: tag}}/>
                );
                resultsCount += Math.min(resultsSize, unsourced[tag].length);
            }
            _results = [... _results, ...unsourced[tag]];
        }
    }

    let releaseName = _results[0] && _results[0].releaseName;
    let artistName = _results[0] && _results[0].artistName;

    let className = "list-results";
    if (isPack || (sourceToSearch && releaseName)) {
        className += " showing-source";
    }
    return (
        <div  ref={ref} className={className}>
            {sourceToSearch && releaseName ? <div className="source-release-name">{artistName} - {releaseName}</div> : ''}
          {isPack ? <div className="source-release-name">
                            <div style={{backgroundColor: colors.getColorForHash(packToSearch.title)}} className="pack-thumb"></div>
                            {packToSearch.title}</div> : ''}
          {list}
        </div>);
}

const mapStateToProps = (state, props) => {
  return {
      showPianoRoll: state.sequencer.showPianoRoll,
      bottomHeight: state.arrangement.bottomHeight
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ListResults);
